import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="hero" className="bg-background flex justify-center items-center overflow-hidden ![padding:128px_0px_64px_0px]">
      <div ref={ref} className={cn("max-w-7xl w-full px-6 flex flex-col items-center text-center transition-all duration-200 ease-smooth", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[20px]")}>
        <h1 className="text-foreground font-sans font-bold text-[48px] leading-[1.2] tracking-[-0.2px] mb-6">What is Making Tax Digital for Income Tax?</h1>
        
        <p className="text-[hsl(0,0%,25%)] text-[16px] leading-[1.6] max-w-[40rem] mb-10 !font-semibold">MTD for Income Tax changes the way sole traders and landlords submit Income Tax returns. Those earning (not profit) above £50,000 need to comply in April 2026, followed by those earning £30,000 who are mandated from April 2027, then those earning £20,000 in 2028. To meet requirements, you must: <br /><br />Keep digital records of all business income and expenditure <br />Submit quarterly updates using HMRC-recognised MTD for IT software <br />Provide a Final Declaration by 31 January, following the tax year</p>
      <div className="mt-8"> <Link to="/team-and-contact#contact-us" className="inline-flex items-center px-6 py-3 bg-primary text-white font-medium rounded-md hover:bg-primary/90 transition"> Contact Us </Link> </div>
        <div className="flex flex-col sm:flex-row gap-4">
          <Button asChild className="bg-primary text-white hover:bg-primary-hover hover:shadow-medium hover:-translate-y-0.5 transition-all duration-200 rounded-[30px] h-auto py-4 px-8 text-lg font-semibold shadow-soft">
            
          </Button>
        </div>
      </div>
    </section>;
}